// a react-three-fiber scene
import React, { useMemo, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { Html, MapControls } from "@react-three/drei";
import { softShadows } from "@react-three/drei";

import "./App.scss";
import * as FA from "react-icons/fa";
import * as THREE from "three";
const activeColor = "orange";

const colors = [
  "#1abc9c",
  "#2ecc71",
  "#3498db",
  "#9b59b6",
  "#34495e",
  "#16a085",
  "#27ae60",
  "#2980b9",
  "#8e44ad",
  "#2c3e50",
  "#f1c40f",
  "#e67e22",
  "#e74c3c",
  "#ecf0f1",
  "#95a5a6",
  "#f39c12",
  "#d35400",
  "#c0392b",
  "#bdc3c7",
  "#7f8c8d",
];

const words = [
  "Net Neutrality",
  "Big Data",
  "Data Mining",
  "Actionable Analytics",
  "Artificial Intelligence",
  "Machine Learning",
  "Personalization",
  "Voice Recognition",
  "Chatbots",
  "Augmented Reality",
  "Virtual Reality",
  "Robotics",
  "Smart Industry 4.0",
  "Internet Of Things",
  "Quantum Computing",
  "Blockchain",
  "Technological Unemployment",
];

softShadows();
export default function Scene5() {
  /*
          <Cube position={[-2, 2]}></Cube>
        <Cube position={[-2, 1]}></Cube>
        <Cube position={[-2, 0]}></Cube>
        <Cube small color="#aaa" position={[-1, 0]}></Cube>
        <Cube position={[-4, 2]}></Cube>
        <Cube></Cube>
        <Cube color=activeColor position={[1, 0]}></Cube>
        <Cube small color="#aaa" position={[4, 2]}></Cube>
        <Cube small color="#aaa" position={[3, 0]}></Cube>
        <Cube small color="#aaa" position={[2, 0]}></Cube>
        <Cube small color="#aaa" position={[-3, 2]}></Cube>
        <Cube color="teal" small position={[-2, 3]}></Cube>
        <Cube color="teal" small position={[-2, 4]}></Cube>
        <Cube color="teal" small position={[-2, 5]}></Cube>
        <Cube color="teal" small position={[-2, 6]}></Cube>
        <Cube position={[3, 1]}></Cube>
        <Cube position={[3, 2]}></Cube>
        <Cube position={[5, 2]}></Cube>
        <Cube position={[6, 2]}></Cube>
  */

  const randomPositions = useMemo(() => {
    let minSpacing = 8;
    return Array.from({ length: 15 }, (_, i) => {
      let randomDirection = Math.random() > 0.5 ? 1 : -1;
      let randomScale = Math.random() * 16;
      return [(randomScale + minSpacing) * randomDirection, 5, -i * minSpacing];
    });
  }, []);
  const [active, setActive] = useState(null);
  return (
    <div style={{ height: "100%" }}>
      <Canvas
        draggable
        shadows
        onCreated={({ gl }) => gl.setClearColor("#ccc")}
        camera={{
          position: [0, 30, 50],
          zoom: 1,
          near: 0.0000001,
          far: 1000000,
          fov: 45,
        }}
      >
        <MainLine></MainLine>
        {randomPositions.map((p, i) => {
          return (
            <IconStack
              index={i}
              setActive={setActive}
              active={active && active[i]}
              doHide={!!active}
              position={p}
            ></IconStack>
          );
        })}
        <ConnectingLine active={active}></ConnectingLine>
        <MapControls maxPolarAngle={Math.PI / 2 - 0.3}></MapControls>
        <directionalLight
          castShadow
          position={[2.5, 8, 5]}
          intensity={1.5}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-far={50}
          shadow-camera-left={-10}
          shadow-camera-right={10}
          shadow-camera-top={10}
          shadow-camera-bottom={-10}
        />
        <ambientLight intensity={1}></ambientLight>
      </Canvas>
    </div>
  );
}

function IconStack({
  position = [0, 0, 0],
  active = false,
  setActive = () => {},
  index,
  doHide,
}) {
  return (
    <group>
      <mesh
        position={[position[0] / 2, 0, position[2]]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <planeBufferGeometry
          args={[position[0] - 0.2, 0.2]}
        ></planeBufferGeometry>
        <meshBasicMaterial
          side={THREE.DoubleSide}
          color={active ? activeColor : "white"}
        ></meshBasicMaterial>
      </mesh>
      <mesh
        position={[position[0] - 0.7, 0, position[2]]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <circleBufferGeometry args={[1, 32]}></circleBufferGeometry>
        <meshBasicMaterial
          side={THREE.DoubleSide}
          color={active ? activeColor : "white"}
        ></meshBasicMaterial>
      </mesh>
      <mesh
        position={[position[0] - 0.7, 0.01, position[2]]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <circleBufferGeometry args={[0.7, 32]}></circleBufferGeometry>
        <meshBasicMaterial
          side={THREE.DoubleSide}
          color="#ccc"
        ></meshBasicMaterial>
      </mesh>
      <group position={position}>
        <Html
          style={{ width: 200, height: 50, display: "block!important" }}
          transform
          translate
        >
          <IconHtml
            index={1}
            setNull={() => setActive(null)}
            setActive={(i) =>
              setActive({
                [index]: i,
                [1 + index + Math.floor(Math.random() * 5)]:
                  Math.floor(Math.random() * 3) + 1,
              })
            }
            doHide={doHide}
            hidden={active !== 1}
          ></IconHtml>
          <IconHtml
            index={2}
            setNull={() => setActive(null)}
            setActive={(i) =>
              setActive({
                [index]: i,
                [1 + index + Math.floor(Math.random() * 5)]:
                  Math.floor(Math.random() * 3) + 1,
              })
            }
            doHide={doHide}
            hidden={active !== 2}
          ></IconHtml>
          <IconHtml
            index={3}
            setNull={() => setActive(null)}
            setActive={(i) =>
              setActive({
                [index]: i,
                [1 + index + Math.floor(Math.random() * 5)]:
                  Math.floor(Math.random() * 3) + 1,
              })
            }
            doHide={doHide}
            hidden={active !== 3}
          ></IconHtml>
        </Html>
      </group>
    </group>
  );
}

function IconHtml({ hidden, setActive, index, doHide, setNull }) {
  let color = useMemo(() => {
    return colors[Math.floor(Math.random() * colors.length)];
  }, []);
  let word = useMemo(() => {
    return words[Math.floor(Math.random() * words.length)];
  }, []);
  let randomIcon = useMemo(() => {
    return randomProperty(FA);
  }, []);
  return (
    <div
      onClick={() => (doHide && !hidden ? setNull() : setActive(index))}
      className="htmlIcon"
      style={{ opacity: doHide && hidden ? 0.4 : 1 }}
    >
      <div className="icon" style={{ backgroundColor: color }}>
        {randomIcon()}
      </div>
      <div className="text">{word}</div>
    </div>
  );
}

var randomProperty = function (obj) {
  var keys = Object.keys(obj);
  return obj[keys[(keys.length * Math.random()) << 0]];
};

function MainLine() {
  return (
    <mesh position={[0, 0, -140]} rotation={[-Math.PI / 2, 0, 0]}>
      <planeBufferGeometry args={[0.2, 600]}></planeBufferGeometry>
      <meshBasicMaterial depthWrite={false} color="#fff"></meshBasicMaterial>
    </mesh>
  );
}

function ConnectingLine({ active }) {
  if (!active) return null;
  let arr = Object.keys(active);
  let mid = (arr[0] * 8 + arr[1] * 8) / 2;
  let length = arr[1] - arr[0];
  console.log(active, arr, mid, length);
  return (
    <mesh position={[0, 0, -mid]} rotation={[-Math.PI / 2, 0, 0]}>
      <planeBufferGeometry args={[0.2, length * 8 + 0.2]}></planeBufferGeometry>
      <meshBasicMaterial color={activeColor}></meshBasicMaterial>
    </mesh>
  );
}
